import { Camera } from "lucide-react";
import PhotoSlot from "./PhotoSlot";
import { MaskedLine, Reveal } from "./motion";

const STATS = [
    { value: "13+", label: "ANNÉES D'EXPÉRIENCE" },
    { value: "07", label: "SPÉCIALITÉS" },
    { value: "02", label: "STUDIO & EXTÉRIEUR" },
];

export default function About() {
    return (
        <section
            id="apropos"
            data-testid="section-about"
            className="relative overflow-hidden border-t border-[#D4AF37]/15 py-24 sm:py-32"
        >
            <div className="pointer-events-none absolute left-1/2 top-0 h-[40vh] w-[70vw] -translate-x-1/2 rounded-full bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.07),transparent_65%)]" />

            <div className="relative z-10 mx-auto grid max-w-[1500px] items-center gap-14 px-5 sm:px-10 lg:grid-cols-12 lg:gap-20">
                <div className="lg:col-span-5">
                    <Reveal y={70}>
                        <div className="relative">
                            <PhotoSlot
                                icon={Camera}
                                image="/photo-apropos.png"
                                alt="Daniel Dulude en veston et chapeau de cowboy avec son appareil Canon, l'ombre d'un cheval derrière lui"
                                ratio="aspect-[4/3]"
                                testId="about-photo-slot"
                            />
                            <div
                                data-testid="about-experience-badge"
                                className="absolute -bottom-6 right-4 border border-[#D4AF37]/40 bg-[#050505] px-6 py-4 shadow-[0_15px_40px_rgba(0,0,0,0.8)] sm:-right-6"
                            >
                                <span className="font-display text-gold-grad block text-3xl font-semibold leading-none">
                                    13
                                </span>
                                <span className="font-mono-lux mt-1 block text-[9px] tracking-[0.3em] text-[#E2E2E2]">
                                    ANS D'EXPÉRIENCE
                                </span>
                            </div>
                        </div>
                    </Reveal>
                </div>

                <div className="lg:col-span-7">
                    <Reveal>
                        <p className="font-mono-lux mb-6 flex items-center gap-4 text-[11px] tracking-[0.4em] text-[#D4AF37]">
                            <span className="inline-block h-px w-10 bg-[#D4AF37]/60" />
                            À PROPOS
                        </p>
                    </Reveal>
                    <h2 className="font-display text-3xl font-medium tracking-tight text-white sm:text-4xl lg:text-5xl">
                        <MaskedLine delay={0.1}>LE GARS DERRIÈRE</MaskedLine>
                        <MaskedLine delay={0.22}>
                            <span className="text-gold-grad italic">
                                LA PHOTO
                            </span>
                        </MaskedLine>
                    </h2>
                    <Reveal delay={0.3}>
                        <p className="font-mono-lux mt-8 text-xs tracking-[0.3em] text-[#E2E2E2]">
                            DANIEL DULUDE — PHOTOGRAPHE
                        </p>
                        <div data-testid="about-bio" className="mt-6 max-w-xl">
                            <p className="font-display text-xl font-light italic leading-relaxed text-[#E2E2E2]/90 sm:text-2xl">
                                « Depuis plus de 13 ans, je photographie ce
                                qui attire mon regard : les gens, les animaux,
                                les paysages et les moments qui méritent
                                d'être conservés.
                            </p>
                            <p className="mt-5 text-base font-light leading-relaxed text-[#E2E2E2]/85 sm:text-lg">
                                Ma façon de travailler est simple : être
                                présent, observer la lumière et capturer
                                l'instant avec authenticité.
                            </p>
                            <p className="mt-5 text-base font-light leading-relaxed text-[#E2E2E2]/85 sm:text-lg">
                                Que ce soit en studio, à l'extérieur ou sur le
                                terrain, chaque séance est une occasion de
                                créer une image qui vous ressemble.
                            </p>
                            <p className="font-display mt-6 text-xl font-light italic leading-relaxed text-[#D4AF37] sm:text-2xl">
                                La photo, pour moi, ce n'est pas seulement
                                appuyer sur un bouton. C'est raconter une
                                histoire. »
                            </p>
                        </div>
                        <p className="font-display mt-6 text-2xl text-[#D4AF37]">
                            — Daniel
                        </p>
                    </Reveal>
                    <Reveal delay={0.4}>
                        <div className="mt-12 grid grid-cols-3 gap-6 border-t border-[#D4AF37]/15 pt-10">
                            {STATS.map((s) => (
                                <div key={s.label}>
                                    <span className="font-display text-gold-grad block text-3xl font-semibold sm:text-4xl">
                                        {s.value}
                                    </span>
                                    <span className="font-mono-lux mt-2 block text-[9px] leading-relaxed tracking-[0.25em] text-[#8A8A8E] sm:text-[10px]">
                                        {s.label}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
